import { StreamId } from "@common/domain";

export class MixerVideoStreamDeleteCmd {
  constructor(readonly streamId: StreamId) {}
}
